import '@hotwired/turbo-rails'
import '../controllers'
import { Turbo } from '@hotwired/turbo-rails'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
}

Turbo.config.forms.confirm = (message) => {
  return new Promise((resolve) => {
    const overlay = document.createElement('div')
    overlay.className = 'fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4'

    const lines = message.split('\n')
    const title = lines[0]
    const body = lines.slice(1).filter(l => l.trim() !== '').join('\n')

    overlay.innerHTML = `
      <div class="bg-[#1a1a1a] border border-[#374151] rounded-xl max-w-sm w-full shadow-2xl">
        <div class="flex items-center justify-between px-5 py-3 border-b border-[#374151]">
          <h2 class="text-amber-400 font-bold text-sm">${title}</h2>
        </div>
        ${body ? `<div class="px-5 py-4 text-xs text-[#9ca3af] whitespace-pre-line">${body}</div>` : ''}
        <div class="flex justify-end gap-2 px-5 py-3 border-t border-[#374151]">
          <button data-cancel class="text-xs px-3 py-1.5 rounded bg-[#2a2a2a] text-[#9ca3af] hover:text-[#e5e5e5] transition-colors">Cancel</button>
          <button data-confirm class="text-xs px-3 py-1.5 rounded bg-amber-700 hover:bg-amber-600 text-white transition-colors">Confirm</button>
        </div>
      </div>
    `

    const close = (result) => {
      overlay.remove()
      resolve(result)
    }

    overlay.querySelector('[data-confirm]').addEventListener('click', () => close(true))
    overlay.querySelector('[data-cancel]').addEventListener('click', () => close(false))
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(false) })
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { document.removeEventListener('keydown', onKey); close(false) }
    })

    document.body.appendChild(overlay)
  })
}
